import React from 'react';
import { Dropdown, Input } from 'semantic-ui-react';
import {map} from 'lodash'
import './ListaDeTiposDePeliculas.scss'

export default function ListaDeTiposDePeliculas({obtenerListaSeleccionada,type,typeShow,arrayLista,nameColeccion}) {

    const [selected,setSelected] = React.useState(null)

    React.useEffect(()=>{
        if(obtenerListaSeleccionada){

            obtenerListaSeleccionada(selected)
        }


    },[selected])



    

  return (
        <Dropdown scrolling text={  selected ? selected : typeShow ? type : nameColeccion} className='dropdown' >
            <Dropdown.Menu className='dropdown_menu'  >
                {

                    arrayLista?.length>0 ?(

                        map(arrayLista,(item)=>(
                            <RenderLista
                                item={item}
                                setSelected={setSelected}
                                key={item.id}
                            />
                        ))
                    ):(
                        <Dropdown.Item
                            text="Agregar una serie"
                        />
                    )
                    
                }
                
            </Dropdown.Menu>
        </Dropdown>
  );
}
function RenderLista ({item,setSelected}){

    return(
        <Dropdown.Item
            text={item?.title}
            className={"dropdown_item"}
            onClick={(e,data)=>setSelected(data.text)}
        />
    )
}
